import { AppLanguageType } from "./StorageProvider";

export const LANGUAGE_OPTIONS: { label: string; value: AppLanguageType }[] = [
  { label: "English", value: "en" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Spanish", value: "es" },
];
